export default __webpack_public_path__ + "static/media/SLIDE_PARRA_6.560259a1.jpeg";